export const sanityFeatureName = 'sanity';
